<template>
    <div>
        <div style="margin: 1px 40px 40px;"></div>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="文件选择" prop="fileName">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    action="1"
                                    :limit="2"
                                    accept=".xls, .xlsx"
                                    :multiple="false"
                                    :on-change="handleFileUpload"
                                    :on-remove="handleFileRmove"
                                    :on-preview="download"
                                    :file-list="this.fileList"
                                    :auto-upload="false">
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                <span slot="tip" style="margin-left:5px; color:#F56C6C; font-size:8px;">（请上传.xls/.xlsx格式文件，大小不能超过10M）</span>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">上传</el-button>
                </el-form-item>
                <el-row><el-col></el-col></el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
            let form = {
                agencyCode: this.entity.agencyCode,
                itemCode: this.entity.itemCode,
                itemName: this.entity.itemName
            }
            let data = {
                fileList: [],
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                form,
                formRules: {
                },
                einvoiceTypeOptions: [],
                supervisorSealOptions: []
            }
            return data
        },
        methods: {
            download() {
                if (this.form.fileBase64 != '' || this.form.fileBase64 != undefined) {
                    this.downloadBase64(this.form.fileName, this.form.fileBase64)
                } else {
                    this.getBase64Online(result => {
                        this.downloadBase64(result.data.fileName, result.data.fileBase64)
                    })
                }
            },
            downloadBase64(fileName, base64) {
                let data_head = 'data:;base64,'
                let a = document.createElement('a')
                a.download = fileName
                a.href = data_head + base64
                document.querySelector("body").appendChild(a)
                a.click()
                document.querySelector("body").removeChild(a)
            },
            handleFileUpload(file, fileList) {
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!isLt2M) {
                    this.$message.error('上传大小不能超过 10MB!')
                    this.$refs.upload.clearFiles();
                    return false
                }
                console.log('handleFileUpload')
                this.form.fileName = file.name
                console.log(fileList.length)
                if(fileList.length > 1){
                    fileList.splice(0,1);
                }
                this.getBase64(file.raw).then(res => {
                    let arr = res.split(',')
                    this.form.fileBase64 = arr[1]
                    this.$refs['form'].validateField('fileName')
                }).catch(e=>{
                    console.log(e)
                })
            },
            handleFileRmove(file, fileList) {
                console.log('handleFileRmove')
                this.form.fileName = ""
                this.form.fileBase64 = ""
            },
            getBase64(file) {
                return new Promise(function (resolve, reject) {
                    let reader = new FileReader()
                    let imgResult = ""
                    reader.readAsDataURL(file)
                    reader.onload = function () {
                        imgResult = reader.result
                    }
                    reader.onerror = function (error) {
                        reject(error)
                    }
                    reader.onloadend = function () {
                        resolve(imgResult)
                    }
                })
            },
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: "IMPORTAGENCYITEMAUX"
            })
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
